@if (siteConfig$ | async; as siteConfig) {
  @if ({ value: desktop$ | async }; as isDesktop) {
    @if (!isDesktop.value) {
      <div class="pb-3">
        <div class="dropdown flex-grow-0" ngbDropdown style="cursor: pointer">
          <button type="button" class="btn btn-outline-primary" ngbDropdownToggle>
            {{ localeLong[this.locale] }}
          </button>
          <div ngbDropdownMenu role="menu">
            <a class="d-flex" ngbDropdownItem href="{{ origin + currentUri }}"> English</a>
            <a class="d-flex" ngbDropdownItem href="{{ origin + '/fr' + currentUri }}">Français</a>
            <a class="d-flex" ngbDropdownItem href="{{ origin + '/es' + currentUri }}">Español</a>
          </div>
        </div>
      </div>
    }
  }
}
